import { create } from "zustand";

export interface FlowType {
	id: string;
	name: string;
	createdAt: string;
	updatedAt: string;
	createdBy: string;
	updatedBy: string;
}

export interface CreateFlowTypeDto {
	name: string;
}

export interface UpdateFlowTypeDto {
	name: string;
}

export interface FlowTypeState {
	// Data
	flowTypes: FlowType[];
	selectedFlowType: FlowType | null;

	// UI States
	isLoading: boolean;
	error: string | null;
	isPanelOpen: boolean;
	isConfirmModalOpen: boolean;
	flowTypeToDelete: FlowType | null;

	// Actions
	setFlowTypes: (flowTypes: FlowType[]) => void;
	setSelectedFlowType: (flowType: FlowType | null) => void;
	setPanelOpen: (isOpen: boolean) => void;
	setConfirmModalOpen: (isOpen: boolean) => void;
	setFlowTypeToDelete: (flowType: FlowType | null) => void;
	setLoading: (loading: boolean) => void;
	setError: (error: string | null) => void;
	resetState: () => void;
}

const initialState = {
	flowTypes: [],
	selectedFlowType: null,
	isLoading: false,
	error: null,
	isPanelOpen: false,
	isConfirmModalOpen: false,
	flowTypeToDelete: null
};

export const useFlowTypeStore = create<FlowTypeState>((set) => ({
	...initialState,

	// State Setters
	setFlowTypes: (flowTypes) => set({ flowTypes }),
	setSelectedFlowType: (flowType) => set({ selectedFlowType: flowType }),
	setPanelOpen: (isOpen) => set({ isPanelOpen: isOpen }),
	setConfirmModalOpen: (isOpen) => set({ isConfirmModalOpen: isOpen }),
	setFlowTypeToDelete: (flowType) => set({ flowTypeToDelete: flowType }),
	setLoading: (loading) => set({ isLoading: loading }),
	setError: (error) => set({ error }),
	resetState: () => set(initialState)
}));
